import { render } from "./eSIMPlans.vue?vue&type=template&id=66b71092&scoped=true&ts=true"
import script from "./eSIMPlans.vue?vue&type=script&lang=ts"
export * from "./eSIMPlans.vue?vue&type=script&lang=ts"

import "./eSIMPlans.vue?vue&type=style&index=0&id=66b71092&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b71092"]])

export default __exports__